// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"actionRedirect_wrapper__2NMMY","container":"actionRedirect_container__28YHA","icon":"actionRedirect_icon__28Fjm"};